// extracted by mini-css-extract-plugin
export default {"downloadCSV":"MbcSearchCsv__downloadCSV___PO3PC"};